module.exports = __webpack_public_path__ + "static/media/muslim_ny.f52036aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/muslim_ny.jpg
// module id = 465
// module chunks = 0